export const formatBlogPostContent = (htmlContent: string | undefined): string => {
	// \n to <br/>
	return (htmlContent?.replace(/\n/g, "<br/>") ?? "").trim();
};
